import { SessionServiceErrorType } from "../../../../interfaces/session-management/enums/error-type";

export class InvalidRefreshTokenError extends Error {
	public name: string;
	public message: string;

	constructor() {
		super('The token is not a valid refresh token.');
		this.name = SessionServiceErrorType.INVALID_REFRESH_TOKEN_ERROR;

		Object.setPrototypeOf(this, InvalidRefreshTokenError.prototype);
	}
}
